import { save, openWhatsapp, getMeta, isDesktop, getMessage, isSendMessageToWhatsappEnabled } from '../store.js';

(($) => {

    async function handleFormSubmission(e, formData) {

        const formId = formData.get('form_id');
        const fields = {}
        // Print all entries
        for (const pair of formData.entries()) {
            fields[pair[0]] = pair[1]
        }

        const widget = document.querySelector('[data-whatsapp]');

        if (widget ) {

            // Inside widget.
            const widgetId = widget.dataset.widget;
            if (!widgetId) return;
 
            const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
            if ( !widgetObject ) return;

            const whatsappConfig = { ...(widgetObject.config.whatsapp || {}), widget_id: widgetId };
            const { new_tab, web_version, forminator_message_template, destination_type, group_invite_code } = whatsappConfig;
            const whatsappNumber = destination_type === 'group' && group_invite_code ? group_invite_code : widget.dataset.whatsapp;
            const message = getMessage(forminator_message_template, fields);
            const data = {
                form: 'forminator',
                form_id: formId,
                field: fields,
                meta: getMeta.value,
                widget_id: widgetId,
            }
            
            try {
                const targetOrigin = (typeof formychat_vars !== 'undefined' && formychat_vars?.site?.url)
                    ? new URL(formychat_vars.site.url).origin : '*';
                window.parent.postMessage({formychat_submitted: JSON.parse(JSON.stringify(data))}, targetOrigin);
            } catch (err) {
            }

            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            if (isSendMessageToWhatsappEnabled(whatsappConfig)) {
                openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1, whatsappConfig);
            }

        } else {
            return;
        }
    }

    $(document).on('forminator:form:submit:success', handleFormSubmission)

})(jQuery)
